import React, { useEffect, useState } from 'react';
import LeaderBoard from '../components/LeaderBoard';
import Navbar from '../components/Navbar';
import styled from 'styled-components';
import { Button, H1, IsValidGame, LinkButton } from '../const';
import Cards from '../components/Cards';
import CreditBalance from '../components/CreditBalance';
import Tamadoge_Logo from '../assets/images/Tamadoge_Logo.png';
import FooterImage from '../assets/images/footer-top-border.svg';
import Instagram from '../assets/socials/instagram.png';
import Telegram from '../assets/socials/telegram.png';
import Reddit from '../assets/socials/raddit.png';
import Twitter from '../assets/socials/twitter.png';
import Discord from '../assets/socials/discord.png';
import GameViewContainer from '../components/Games';
import { gameDetails, prizePool } from '../services/ApiServices';
import { ImageUrl } from '../const';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { BugBountyModal } from '../components/BugBountyModal';

const HeadContainer = styled.div`
    display: flex;
    width: 70%;
    justify-content: space-between;

    @media screen and (max-width: 768px) {
        width: unset;
        margin: 0 20px;
    }
    h1 {
        @media screen and (max-width: 1024px) {
            font-size: 20px;
            margin-top: 30px !important;
            line-height: 20px !important;
        }
        @media screen and (max-width: 577px) {
            font-size: 15px;
        }
        @media screen and (max-width: 420px) {
            font-size: 12px;
            line-height: 15px !important;
        }
    }
`;

const BoardContainer = styled.div`
    display: flex;
    justify-content: space-around;
    @media screen and (max-width: 768px) {
        flex-direction: column;
    }
`;

const GameContainer = styled.div`
    width: 70%;
    border-radius: 10px;
    padding-bottom: 10px;
    @media screen and (max-width: 768px) {
        width: unset;
        margin: 10px 20px;
    }
`;

const OtherGameContainer = styled.div`
    display: flex;
    justify-content: space-between;
    margin-top: 20px;
    gap: 20px;
    @media screen and (max-width: 635px) {
        flex-wrap: wrap;
    }
`;

const OuterConatainer = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    height: 500px;
    @media screen and (max-width: 768px) {
        height: unset;
        margin-top: 20px;
    }
`;

const CreditLeaderContainer = styled.div`
    margin: 20px;
    @media screen and (min-width: 769px) {
        width: 27%;
        margin: 0;
    }
`;

const InnerConatainer = styled.div`
    display: flex;
    justify-content: space-between;
    position: relative;
    width: 80%;
    height: 80%;
    background: #fff;
    padding: 20px;
    &.how-to-play {
        border-radius: 25px;
    }
    .how-to-play-img {
        width: 40%;
        object-fit: contain;
    }
    .super-doge-background {
        width: 20%;
        margin-right: 5% !important;
        object-fit: contain;
    }
    .to-the-moon-background {
        width: 25%;
        margin-right: 5% !important;
        object-fit: contain;
    }
    .rocket-doge-background {
        width: 25%;
        margin-right: 5% !important;
        object-fit: contain;
    }

    @media screen and (max-width: 768px) {
        flex-direction: column;
        height: fit-content;
        align-items: center;
        &.how-to-play {
            border-radius: 15px;
        }
        .super-doge-background{
            margin: 20px 0;
            width: 30%;
        }
        .to-the-moon-background {
            margin: 40px 0;
            width: 50%
        }
        .rocket-doge-background {
            margin: 40px 0;
            width: 40%
        }
        .how-to-play-img {
            margin: 40px 0;
            width: 50%;
        }
    }
    @media screen and (max-width: 577px) {
        .rocket-doge-background {
            width: 60%
        }
    }
`;

const TabViewContainer = styled.div`
    display: flex;
`;

const TabView = styled.div`
    padding: 10px;
    margin-right: 20px;
    display: flex;
    cursor: pointer;
    transition: 0.3s ease-in-out;
    border-radius: 5px 5px 0 0;
    img {
        height: 50px;
        width: 50px;
        object-fit: contain;
        background-color: 'white';
    }
    @media screen and (max-width: 577px) {
        margin-right: 10px !important;
        img {
            height: 25px !important;
            width: 25px !important;
        }
    }
`;

const ContentConatainer = styled.div`
    text-align: center;
    position: relative;
    width: 50%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    p,
    .description {
        font-size: 16px;
        font-family: 'Open sans';
        margin:5px 0;
    }
    &.buy-content {
        width: 45%;
        background: #fff;
        p {
            margin: 0 30px;
        }
        button {
            margin: 30px 0;
        }
    }
    &.background-section {
        width: 65%;
    }
    .super-doge-desc{
        width: 80%;
    }
    .rocket-doge-desc{
        width: 66%;
    }
    .to-the-moon-desc{
        width: 80%;
    }
    @media screen and (min-width: 450px) and (max-width: 768px) {
      .super-doge-desc{
        width: 75% !important;
      }
    }
    
    @media screen and (max-width: 768px) {
        width: 100%;
        p,
        .description {
            font-size: 13px;
            width: 80%;
        }
        .rocket-doge-desc{
          width: 50% !important;
        }
        &.buy-content {
            width: calc(100% + 40px);
            margin-bottom: 30px;
        }
        &.background-section {
            width: 100%;
            margin: 30px 0;
        }
    }
    @media screen and (max-width: 577px) {
       .rocket-doge-desc{
         width: 90% !important;
       }
    }
`;

const Footer = styled.div`
    background: #f7f797;
    padding-bottom: 20px;
    .inner-content {
        display: flex;
        justify-content: space-around;
        h1 {
            color: #132e50;
        }
        a {
            line-height: 20px;
            padding: 7px 0;
            transition: all 0.3s ease-in-out;
            &:hover {
                font-weight: 600;
                color: #132e50;
            }
        }
    }
    .copy-right {
        display: flex;
        width: 100%;
        justify-content: center;
    }
    p,
    a {
        color: #414141;
        font-family: 'Montserrat';
        font-size: 15px;
        cursor: pointer;
        display: flex;
        padding: 2px;
        text-decoration: none;
        font-weight: 400;
        img {
            margin-right: 10px;
        }
    }
    a {
        padding: 10px 0;
    }
    @media screen and (max-width: 577px) {
        .inner-content {
            flex-wrap: nowrap;
            flex-direction: column;
            align-items: start;
            padding: 0 20px;
            h1 {
                font-size: 25px;
                margin: 0;
            }
            margin: 0 5px;
        }
    }
`;

const BackgroundBottomImage = styled.img`
    position: absolute;

    &.super-doge-left{
        height: 130px;
        left: -30px;
        bottom:-30px;
    }
    &.super-doge-right{
        height: 90px;
        right: -30px;
        bottom:-30px;
    }
    &.to-the-moon-left{ 
       bottom: 0px;
       height: 100px;
       left:0;
    }
    &.to-the-moon-right{ 
       bottom: 0px;
       height: 100px;
       right:0;
    }
    &.rocket-doge-left{ 
       bottom: 0px;
       height: 100px;
       left:0;
    }
    &.rocket-doge-right{ 
       bottom: -30px;
       height: 140px;
       right:-20px;
    }
    @media screen and (max-width: 768px) {
        &.super-doge-left{
           height: 100px;
        }
        &.super-doge-right{
           height: 80px;
        }
        &.to-the-moon-left{ 
           height: 50px;
        }
        &.to-the-moon-right{ 
           height: 50px;
        }
        &.rocket-doge-left{ 
           height: 50px;
        }
        &.rocket-doge-right{ 
           bottom: -20px;
           height: 100px;
           right:-10px;
        }
    }
    @media screen and (max-width: 577px) {
        &.super-doge-left{
           height: 70px;
           left: -15px;
           bottom:-30px;
        }
        &.super-doge-right{
           height: 50px;
           right: -10px;
           bottom:-20px;
        }
        &.to-the-moon-left{ 
           height: 50px;
        }
        &.to-the-moon-right{ 
           height: 50px;
        }
        &.rocket-doge-right{ 
            height: 80px;
        }
    }
`;

const HowToPlayBottomImage = styled.img`
    position: absolute;
    right: -30px;
    bottom: -30px;
    width: 100px;
    @media screen and (max-width: 768px) {
        right: -10px;
        bottom: -10px;
        width: 60px;
    }
`;

const TokenImage = styled.img`
    position: absolute;
    right: -50px;
    bottom: -30px;
    width: 120px;
    object-fit: contain;
    @media screen and (max-width: 768px) {
        right: -15px;
        bottom: -20px;
        width: 80px;
    }
`;

const  HowToBuySection = styled.div`
    @media screen and (max-width: 768px) {
         margin-top: 50px;
    }
`
// const BottomText = styled.a`
//   color: #132e50;
//   margin: 0 10px;
//   font-size: 16px;

//   @media screen and (max-width: 768px) {
//     font-size: 12px;
//   }
// `;

window.Buffer = window.Buffer || require('buffer').Buffer;
function Home() {
    const [data, setData] = useState();
    const [active, setActive] = useState(0);
    const [showModal, setShowModal] = useState(false);
    const [token, setToken] = useState(localStorage.getItem('token'));
    const [isMobile, setIsMobile] = useState(false);
    const [otherGames, setOtherGame] = useState();
    const [validUrl, setValidUrl] = useState(false);
    const [prizepool, setPrizepool] = useState(0);
    const [isFeedback, setIsFeedback] = useState(false)

    const CURRENT_WB_NAME =
        window.location.pathname.split('/')[1] || 'super-doge';
    const { t } = useTranslation();
    const navigate = useNavigate();

    useEffect(() => {
        const environment = process.env.REACT_APP_NODE_ENV;
        localStorage.setItem("environment",environment);
     },[])

    useEffect(() => {
        if (!IsValidGame(CURRENT_WB_NAME)) {
            navigate('/super-doge');
        } else {
            setValidUrl(true);
        }
        if (
            /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
                navigator.userAgent
            )
        ) {
            setIsMobile(true);
        }
        validUrl &&
            gameDetails(CURRENT_WB_NAME)
                .then((response) => {
                    setData(response.data.data);
                    prizePool(response.data.data.gameId)
                        .then((response) => {
                            setPrizepool(response.data.data.prize);
                        })
                        .catch((err) => err);
                    const isLaunched = response.data.data.otherGameData.filter(
                        (e) => e.isLaunched
                    );
                    const isNotLaunched =
                        response.data.data.otherGameData.filter(
                            (e) => !e.isLaunched
                        );
                    setOtherGame([...isLaunched, ...isNotLaunched]);
                })
                .catch((error) => error);
    }, [CURRENT_WB_NAME, navigate, validUrl]);

    const slug = data ? t(`${data.name}`).toLowerCase().trim().replace(/[^\w\s-]/g, '').replace(/[\s_-]+/g, '-').replace(/^-+|-+$/g, '') : '';
    return (
        <div style={{ background: data ? data.backgroundColour : 'white' }}>
          <BugBountyModal isFeedback={isFeedback} setIsFeedback={setIsFeedback}/>
            {data && (
                <>
                    <Navbar
                        setShowModal={setShowModal}
                        background={data.backgroundColour}
                        setIsFeedback={setIsFeedback}
                    />
                    <div className='container'>
                        <HeadContainer>
                            <H1
                                style={{
                                    marginLeft: '10px',
                                    lineHeight: '40px',
                                }}
                            >
                                {t(`${data.name}`)}
                            </H1>
                            <H1
                                style={{
                                    marginLeft: '10px',
                                    lineHeight: '40px',
                                }}
                            >
                                {`${t('prize_pool')} ${prizepool} ${t('tama')}`}
                            </H1>
                        </HeadContainer>
                        <BoardContainer>
                            <GameContainer>
                                <div>
                                    <GameViewContainer
                                        params={CURRENT_WB_NAME}
                                        isMobile={isMobile}
                                        token={token}
                                    />
                                </div>
                                <OtherGameContainer>
                                    {otherGames.map((data, index) => (
                                        <Cards
                                            index={index}
                                            data={data}
                                            key={index}
                                        />
                                    ))}
                                </OtherGameContainer>
                            </GameContainer>
                            <CreditLeaderContainer>
                                <CreditBalance
                                    showModal={showModal}
                                    setShowModal={setShowModal}
                                    token={token}
                                    setToken={setToken}
                                    isMobile={isMobile}
                                />
                                <LeaderBoard
                                    token={token}
                                    gameId={data.gameId}
                                />
                            </CreditLeaderContainer>
                        </BoardContainer>
                        <OuterConatainer className='credit-leader'>
                            <InnerConatainer>
                                <ContentConatainer className='background-section'>
                                    <H1 style={{ lineHeight: '30px' }} className={`${slug}-background-title`}>
                                        {t(`${data.background.title}`)}
                                    </H1>
                                    <p className={`description ${slug}-desc`}>
                                        {t(`${data.background.description}`)}
                                    </p>
                                </ContentConatainer>
                                <img
                                    src={
                                        ImageUrl +
                                        data.background.backgroundTopRight
                                    }
                                    alt=''
                                    className={`${slug}-background`}
                                />
                                <BackgroundBottomImage
                                    src={
                                        ImageUrl +
                                        data.background.backgroundBottomLeft
                                    }
                                    alt=''
                                    className={`${slug}-left`}
                                />
                                <BackgroundBottomImage
                                    src={
                                        ImageUrl +
                                        data.background.backgroundBottomRight
                                    }
                                    alt=''
                                    className={`${slug}-right`}
                                />
                            </InnerConatainer>
                        </OuterConatainer>
                        <HowToBuySection>
                        <H1 style={{ textAlign: 'center' }}>
                            {t('how_to_play')}
                        </H1>

                        <OuterConatainer style={{ flexDirection: 'column' }}>
                            <TabViewContainer>
                                {data.howToPlay.map((item, index) => {
                                    return (
                                        <TabView
                                            onClick={() => setActive(index)}
                                            style={{
                                                backgroundColor:
                                                    active === index
                                                        ? 'white'
                                                        : '#ffffff80',
                                            }}
                                            key={index}
                                        >
                                            <img
                                                src={
                                                    ImageUrl + item.howToPlayTab
                                                }
                                                alt=''
                                                style={{
                                                    height: 50,
                                                    width: 50,
                                                    objectFit: 'contain',
                                                }}
                                            />
                                        </TabView>
                                    );
                                })}
                            </TabViewContainer>
                            <InnerConatainer className='how-to-play'>
                                <img
                                    src={
                                        ImageUrl +
                                        data.howToPlay[active].howToPlayLeft
                                    }
                                    alt=''
                                    className='how-to-play-img'
                                />
                                <ContentConatainer>
                                    <H1 style={{ lineHeight: '35px' }}>
                                        {t(`${data.howToPlay[active].title}`)}
                                    </H1>
                                    <p className='description'>
                                        {t(
                                            `${data.howToPlay[active].description}`
                                        )}
                                    </p>
                                </ContentConatainer>
                                <HowToPlayBottomImage
                                    src={
                                        ImageUrl +
                                        data.howToPlay[active].howToPlayRight
                                    }
                                    alt=''
                                />
                            </InnerConatainer>
                        </OuterConatainer>
                        </HowToBuySection>
                        <H1
                            style={{
                                textAlign: 'center',
                                marginBottom: 0,
                                marginTop: '80px',
                            }}
                        >
                            {t('tokens_nft_title')}
                        </H1>
                        <OuterConatainer>
                            <InnerConatainer style={{ background: 'inherit' }}>
                                <ContentConatainer className='buy-content'>
                                    <H1>
                                        {t('buy_tamadoge')} {t('tokens')}
                                    </H1>
                                    <p>{t('buy_tama_tokens_desc')}</p>
                                    <LinkButton
                                        style={{
                                            background: '#F8D760',
                                            padding: '0px 40px',
                                            margin: '25px 0',
                                        }}
                                        href='https://tamadoge.io/tokens/'
                                        target='_blank'
                                        rel='noreferrer'
                                    >
                                        {t('buy_now')}
                                    </LinkButton>
                                    <TokenImage
                                        src={ImageUrl + data.buyTama}
                                        alt='bottom-left'
                                    />
                                </ContentConatainer>
                                <ContentConatainer className='buy-content'>
                                    <H1>{t('buy_tamadoge')} NFTS</H1>
                                    <p>{t('buy_tama_nfts_desc')}</p>
                                    <LinkButton
                                        style={{
                                            background: '#F8D760',
                                            padding: '0px 40px',
                                            margin: '25px 0',
                                        }}
                                        href='https://tamadoge.io/nfts/'
                                        target='_blank'
                                        rel='noreferrer'
                                    >
                                        {t('buy_now')}
                                    </LinkButton>
                                </ContentConatainer>
                            </InnerConatainer>
                        </OuterConatainer>
                        <div
                            style={{
                                display: 'flex',
                                justifyContent: 'center',
                                marginBottom: '20px',
                            }}
                        >
                            <img
                                src={Tamadoge_Logo}
                                style={{ height: '50px' }}
                                alt='logo'
                            />
                        </div>
                        <div
                            style={{
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center',
                                marginBottom: '20px',
                            }}
                        >
                            <Button
                                className='bottom-btn'
                                onClick={() => setShowModal(true)}
                            >
                                {' '}
                                {t('buy_now')}
                            </Button>
                            {/* <BottomText href=" "> {t("how_to_buy")}</BottomText>
              <BottomText href=" ">{t("new_to_crypto")}</BottomText> */}
                        </div>
                    </div>
                    <Footer>
                        <img src={FooterImage} alt='footer' width='100%' />
                        <div className='inner-content container'>
                            <div>
                                <H1>TAMADOGE</H1>
                                {/* <p>{t("buy_tamadoge")}</p>
                <p>{t("about")}</p>
                <p>{t("eco_system")}</p>
                <p>{t("roadmap")}</p> */}
                                <a
                                    href='https://tamadoge.io/wp-content/uploads/2022/10/Tamadoge-Whitepaper-ENG.pdf'
                                    target='_blank'
                                    rel='noreferrer'
                                >
                                    {t('whitepaper')}
                                </a>
                                <a
                                    href='https://tamadoge.io/wp-content/uploads/2022/10/SmartContract_Audit_Solidproof_Tamadoge.pdf'
                                    target='_blank'
                                    rel='noreferrer'
                                >
                                    {t('solid_proof')}
                                </a>
                                <a
                                    href='https://coinsniper.net/coin/37091'
                                    target='_blank'
                                    rel='noreferrer'
                                >
                                    {t('coinsniper')}
                                </a>
                                <a
                                    href='https://tamadoge.io/privacy-policy/'
                                    target='_blank'
                                    rel='noreferrer'
                                >
                                    {t('privacy_policy')}
                                </a>
                                <a
                                    href='https://tamadoge.io/cookie-policy/'
                                    target='_blank'
                                    rel='noreferrer'
                                >
                                    {t('cookie_policy')}
                                </a>
                                <a
                                    href='https://tamadoge-p2e-media-dev.s3.eu-west-2.amazonaws.com/document/Tama+draft+terms.pdf'
                                    target='_blank'
                                    rel='noreferrer'
                                >
                                    {t('term_conditions')}
                                </a>
                            </div>
                            {/* <div>
                                <H1>LINKS</H1>
                                <p>Contact</p>
                                <p>Press</p>
                                <p>New to Crypto?</p>
                                <p>How to buy</p>
                            </div> */}
                            <div>
                                <H1>{t('community')}</H1>
                                <a
                                    href='https://www.instagram.com/tamadogecoin/'
                                    target='_blank'
                                    rel='noreferrer'
                                >
                                    <img src={Instagram} alt='Instagram' />
                                    {t('instagram')}
                                </a>
                                <a
                                    href='https://t.me/+CmOuE10rjGFjNDI0'
                                    target='_blank'
                                    rel='noreferrer'
                                >
                                    <img src={Telegram} alt='Telegram' />
                                    {t('telegram')}
                                </a>
                                <a
                                    href='https://www.reddit.com/r/TamadogeOfficial/'
                                    target='_blank'
                                    rel='noreferrer'
                                >
                                    <img src={Reddit} alt='Reddit' />
                                    {t('reddit')}
                                </a>
                                <a
                                    href='https://twitter.com/Tamadogecoin'
                                    target='_blank'
                                    rel='noreferrer'
                                >
                                    <img src={Twitter} alt='Twitter' />
                                    {t('twitter')}
                                </a>
                                <a
                                    href='https://discord.com/invite/Z2PqFvsXJa'
                                    target='_blank'
                                    rel='noreferrer'
                                >
                                    <img src={Discord} alt='Discord' />
                                    {t('discord')}
                                </a>
                            </div>
                        </div>
                        <div className='copy-right'>
                            <p>{t('copyright')}</p>
                        </div>
                    </Footer>
                </>
            )}
        </div>
    );
}

export default Home;
